/**
 * The Criteria Lab's internal workspace, seeded by migration. It is hidden from every
 * workspace list and reached only through the Lab page, so code listing a user's
 * workspaces filters it out by this slug.
 */
export const CRITERIA_LAB_WORKSPACE_SLUG = 'criteria-lab';

/**
 * Site columns that tag a Lab test site copied from a client workspace with its origin.
 * The database deletes copies with their client workspace by `source_workspace_id`.
 */
export const LAB_SITE_SOURCE_COLUMNS = {
  workspaceId: 'source_workspace_id',
  rowId: 'source_row_id',
} as const;
